module.exports = __webpack_public_path__ + "static/media/Business_white.7b55f846.svg";